export default function http(url, auth, token, delay = 0, format = 'json', method = 'GET', payload, onProgress) {
  

  return new Promise((resolve, reject) => {
    //url += '&queryTimeout=300000';
    var request = new XMLHttpRequest();
    request.open(method, http.auth(url,auth,token), true);
    request.timeout = 0;
    request.onerror = reject;
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (!request.responseText) {
          reject('Empty response text');
        } else if (format == 'json') {
          try {
            resolve(funJSON.parse(request.responseText));
          } catch (ex) {
            reject(ex);
          }
        } else {
          resolve(request.responseText);
        }
      } else {
        reject(`Failed to get response: ${request.status} - ${request.responseText}`);
      }
    };

    if(onProgress){

      // request.onprogress = (ev) => {
      //   if (ev.lengthComputable) 
      //   {
      //     onProgress(Math.round(ev.loaded * 100 / ev.total));
      //   }        
      // }

      request.upload.addEventListener('progress', 
        (ev) => {
          if (ev.lengthComputable) 
          {
            onProgress(Math.round(ev.loaded * 100 / ev.total));
          }        
        }, false);
    }

    setTimeout(function() {
      try {
        request.send(payload);
      } catch (ex) {
        reject(ex);
      }
    }, delay);
  });
}

http.auth = function(url, auth, token){
  auth = _.isFunction(auth) ? auth() : auth;
  token = _.isFunction(token) ? token() : token;
  auth = auth || token && 'x-session-token=' + token;
  if(auth){    
    if(url.indexOf('?')!==-1){url+='&'+auth;}
    else{url+='?'+auth;}
  }

  return url;
}